module.exports = __WEBPACK_EXTERNAL_MODULE_174__;


//////////////////
// WEBPACK FOOTER
// external "gemini/dashboard/model/content/ContentModel"
// module id = 174
// module chunks = 0